<div id="main-container" appViewportSizeMonitor>
    <div *ngIf="loading$ | async" class="spinner-backdrop">
	  <div class="spinner-container">
	    <div class="spinner-box">
	      <i class="fas fa-spinner fa-spin fa-fw fa-2x"></i> 
	      <div class="spinner-text">{{ message$ | async }}</div>
	    </div>
	  </div>
	</div>
    <div class="desktop main">
        <h1 class="sr-only">{{ LOCALIZATION.advancedSearch }}</h1>
		<div *ngIf="!states.detached && !states.mapDetach" class="searchBar">
		  <searchbar *ngIf="userPermissions && simpleSearch" 
		  [userPermissions]="userPermissions" 
		  [simpleview]="simpleview" 
		  [user]="user"
		  [LOCALIZATION]="LOCALIZATION" 
		  [mapViewEnabled]="mapViewEnabled" 
		  [mapDetached]="mapDetached" 
		  [isMoreLikeThisEnabled]="isMoreLikeThisEnabled"  
		  [recordsMgmtServicesEnabled]="recordsMgmtServicesEnabled" 
		  [searchResults]="searchResults" 
		  [streamingQueries]="streamingQueries" 
		  [states]="states" 
		  [viewerMode]="viewerMode" 
		  [simpleSearch]="simpleSearch.bind(this)"
		  [toggleAdvanced]="toggleAdvanced.bind(this)"
		  [doCleanSearches]="doCleanSearches.bind(this)"
		  [saveSearch]="saveSearch.bind(this)"
		  [changeView]="changeView.bind(this)"
		  [newSearch]="doCleanSearches.bind(this)"
		  ></searchbar>
		</div>
    </div>
    
	<div id="searchBarContainer" class="flex mobile">
	  <searchbar
	    *ngIf="userPermissions && !states?.detached && !states?.mapDetach"
	    class="searchBar" 
	    [userPermissions]="userPermissions" 
		[simpleview]="simpleview" 
		[user]="user"
		[LOCALIZATION]="LOCALIZATION" 
		[mapViewEnabled]="mapViewEnabled" 
		[mapDetached]="mapDetached" 
		[isMoreLikeThisEnabled]="isMoreLikeThisEnabled"  
		[recordsMgmtServicesEnabled]="recordsMgmtServicesEnabled" 
		[searchResults]="searchResults" 
		[streamingQueries]="streamingQueries" 
		[states]="states"
		[viewerMode]="viewerMode"
		[simpleSearch]="simpleSearch.bind(this)"
		[toggleAdvanced]="toggleAdvanced.bind(this)"
		[doCleanSearches]="doCleanSearches.bind(this)"
		[saveSearch]="saveSearch.bind(this)"
		[changeView]="changeView.bind(this)"
		[newSearch]="doCleanSearches.bind(this)"
		></searchbar>
	    <!-- Dropdown for view mode toggle -->
		<div id="viewer-toggle" ngbDropdown #dropdownRef="ngbDropdown">
		  <button
		    type="button"
		    id="views-mode-button"
		    class="btn btn-primary"
		    ngbDropdownToggle
		    title="Change view"
		    aria-haspopup="true">
		    	{{ viewerMode }}
		    	<span style="margin-left: 0.5em;" class="caret"></span>
		  </button>
		  <ul class="dropdown-menu custom-drop" style="width: 100%;" ngbDropdownMenu role="menu" aria-labelledby="views-mode-button">
			<li class="w-100" style="width: 100%;">
		        <a
		          title="{{ LOCALIZATION?.results }}"
		          style="z-index:0" 
		          (click)="onViewerModeChange('Results',dropdownRef)">
		          {{ LOCALIZATION.results }}
		        </a>
	        </li> 
			<li class="w-100" style="width: 100%;">
		        <a
		          title="{{ LOCALIZATION?.searchCriteria }}"
		          style="z-index:0" 
		          (click)="onViewerModeChange('Filters',dropdownRef)">
		          {{ LOCALIZATION.filters }}
		        </a>
	        </li> 
		  </ul>
		</div>
	</div>
<!-- 	Mobile-only Advanced panel  -->
    <div 
    	*ngIf="(isMobile && viewerMode === 'Filters')" 
    	class="advancedHolder mobile results-view" 
    	caSidebar 
    	[resizevar]="resizeVar" 
    	[screen]="screen">
       	<kv-advanced></kv-advanced>
    </div>
<!-- 	Desktop and Mobile  -->    
	<div 
	  *ngIf="(isMobile && viewerMode === 'Results') || !isMobile"
	  class="row"
	  id="searchContent"
	  [ngStyle]="mainContentStyling"
	  [ngClass]="{
	    'searchContent': !states.detached && !states.mapDetach,
	    'searchContent-detached': states.detached || states.mapDetach
	  }">
	  <div id="advancedPanelMainConent"
	    class="hidden-xs"
	    [ngClass]="{ advancedClosed: !states.advancedOpen }">
	      <div class="advancedHolder" caSidebar [resizevar]="resizeVar" [screen]="screen">
	        <kv-advanced></kv-advanced>
	      </div>
	  </div>
	  <div #resizer id="dragMe" class="resizer desktop"></div>
	  <div id="maincontent" [ngClass]="{ 'advancedClosed': !states.advancedOpen }" class="browseClosed relative-mobile">
	  <!--  TABS -->  
		<div id="main_content_tabs" class="mobile">
		  <div class="btn-group view-modes-group relative">
		    <!-- Grid view button -->
		    <label
		      title="{{ LOCALIZATION.grid }}"
		      style="z-index: 0"
		      (click)="changeView('G')"
		      class="btn btn-primary custom-viewer-select"
		      [ngClass]="{ active: states.currentView === 'G' }"
		    >
		      <span class="fa fa-table"></span>
		    </label>
		
		    <!-- List view button -->
		    <label
		      *ngIf="!userPermissions['BLOCK_LIST_VIEW']"
		      title="{{ LOCALIZATION.list }}"
		      style="z-index: 0"
		      (click)="changeView('L')"
		      class="btn btn-primary custom-viewer-select"
		      [ngClass]="{ active: states.currentView === 'L' }"
		    >
		      <span class="fas fa-th-list"></span>
		    </label>
		
		    <!-- Thumbnail view button -->
		    <label
		      *ngIf="!userPermissions['BLOCK_THUMBNAIL_VIEW']"
		      title="{{ LOCALIZATION.thumbnail }}"
		      style="z-index: 0"
		      (click)="changeView('T')"
		      class="btn btn-primary custom-viewer-select"
		      [ngClass]="{ active: states.currentView === 'T' }"
		    >
		      <span class="fa fa-th-large"></span>
		    </label>
		
		    <!-- Records Management view button -->
		    <label
		      *ngIf="recordsMgmtServicesEnabled && userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW']"
		      title="{{ LOCALIZATION.recordsManagement }}"
		      style="z-index: 0"
		      (click)="changeView('R')"
		      class="btn btn-primary custom-viewer-select"
		      [ngClass]="{ active: states.currentView === 'R' }"
		    >
		      <span class="fas fa-folder"></span>
		    </label>
		
		    <!-- Map view button -->
		    <label
		      *ngIf="mapViewEnabled && !mapDetached && !userPermissions['BLOCK_MAP_VIEW']"
		      title="{{ LOCALIZATION.map }}"
		      style="z-index: 0"
		      (click)="changeView('M')"
		      class="btn btn-primary custom-viewer-select"
		      [ngClass]="{ active: states.currentView === 'M' }"
		    >
		      <span class="fas fa-globe-americas"></span>
		    </label>
		
		    <!-- Simple view button -->
		    <label
		      *ngIf="simpleview?.enabled"
		      title="{{ LOCALIZATION.simpleView }}"
		      style="z-index: 0"
		      (click)="changeView('S')"
		      class="btn btn-primary custom-viewer-select"
		      [ngClass]="{ active: states.currentView === 'S' }"
		    >
		      <span class="fa fa-list-alt"></span>
		    </label>
		  </div>
		
		  <!-- Dropdown for sorting, shown when the current view is not 'M' -->
			<div *ngIf="states.currentView !== 'M'" class="btn-group dropdown desktop" ngbDropdown 
				  #dropdownRef="ngbDropdown" style="float:right;">
			  <button
			    id="sort-button-nomap"
			    type="button"
			    class="btn btn-primary submit-button submit-button-sm"
			    ngbDropdownToggle
			    [disabled]="false"
			    [ngClass]="{
			      dropdown: !sort || (sort && sort.direction !== 'ASC'),
			      dropup: sort?.direction === 'ASC'
			    }"
			  >
			    Sort by
			    <span class="badge" *ngIf="sort">{{ sort?.field?.displayName ?? ''}}</span>
			    <span class="badge" *ngIf="!sort">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
			    <span class="caret"></span>
			  </button>
			
			  <ul
			    class="dropdown-menu custom-drop sort-menu"
			    ngbDropdownMenu
			    role="menu"
			    aria-labelledby="sort-button-nomap"
			    style="min-width:130px; max-width:130px; max-height:70%; overflow-y: auto;"
			  >
			    <li
			      role="menuitem"
			      *ngFor="let field of sortFieldsShow"
			      (click)="onSortSelected(field, dropdownRef)"
			      style="min-width:130px; max-width:130px;"
			    >
			      <a style="max-width:inherit; white-space:initial;">{{ field.displayName }}</a>
			    </li>
			  </ul>
			</div>
		</div>
        <div id='maincontent_header'>
         <!-- global record selector -->
        <div *ngIf="searchResults && !searchResults.error" class="resultText">
			  <label *ngIf="!userPermissions['BLOCK_SEARCH_CHECK']" style="display: inline;padding-left: 20px;margin-bottom: 20px;" class="control control--checkbox">
			    <input
			      type="checkbox"
			      [(ngModel)]="globalRecords.all"
			      (change)="toggleCheckbox()"
			      aria-label="Select All"
			      [title]="LOCALIZATION.selectAll"
			    />
			    <div class="global-checkbox badge" [ngClass]="{ 'not-empty': globalRecordIds.length > 0 }">
			      {{ globalRecordIds.length === 0 ? '' : globalRecordIds.length }}
			    </div>
			  </label>
			
			  <div
			    *ngIf="!userPermissions['BLOCK_SEARCH_DROPDOWN']"
			    ngbDropdown
			    class="dropdown"
			    style="display:inline"
			    id="batch-operations-div"
			  >
			  <button ngbDropdownToggle
			      id="batch-actions-menu-button"
				  type="button"
				  class="dropdown-toggle btn-xs"
				  aria-haspopup="true"
				  aria-expanded="true"
				  [attr.aria-label]="LOCALIZATION.batchOperations"
				  title="{{ LOCALIZATION.batchOperations }}"
				  style="border: 0; background: transparent;">
				  	<i class="result-nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
				</button>
			    <ul ngbDropdownMenu class="dropdown-menu custom-drop scrollable-menu-list" aria-labelledby="batch-actions-menu-button" role="menu">
			      <li *ngIf="canEdit()" role="menuitem">
			        <a [title]="LOCALIZATION.edit" (click)="globalEdit()">{{ LOCALIZATION.edit }}</a>
			      </li>
			
			      <li *ngIf="canEdit()" role="menuitem">
			        <a [title]="LOCALIZATION.editBrowse" (click)="globalBrowseEdit()">{{ LOCALIZATION.editBrowse }}</a>
			      </li>
			
			      <li *ngIf="canDelete()" role="menuitem">
			        <a [title]="LOCALIZATION.deleteItem" (click)="globalDelete()">{{ LOCALIZATION.deleteItem }}</a>
			      </li>
			
			      <li *ngIf="canEdit() || canDelete()" class="dropdown-divider" role="separator"></li>
			
			      <li *ngIf="records.length > 0" role="menuitem">
			        <a [title]="LOCALIZATION.printResults" (click)="printProductResults()">{{ LOCALIZATION.printResults }}</a>
			      </li>
			
			      <li *ngIf="canDownload() && globalRecordIds.length > 0" role="menuitem">
			        <a [title]="LOCALIZATION.downloadResults" (click)="downloadProducts()">{{ LOCALIZATION.downloadResults }}</a>
			      </li>
			
			      <li *ngIf="userPermissions['ROLE_USERS_EMAIL'] && records.length > 0" role="menuitem">
			        <a [title]="LOCALIZATION.emailResults" (click)="sendProducts()">{{ LOCALIZATION.emailResults }}</a>
			      </li>
			
			      <li *ngIf="citationsEnabled && globalRecordIds.length > 0 && globalRecordIds.length <= 500" role="menuitem">
			        <a [title]="LOCALIZATION.citations" (click)="createCitations()">{{ LOCALIZATION.citations }}</a>
			      </li>
			
			      <li *ngIf="userPermissions['ROLE_PRODUCT_DOWNLOAD'] && globalRecordIds.length > 1" role="menuitem">
			        <a [title]="LOCALIZATION.multiDocView" (click)="compareProducts()">{{ LOCALIZATION.multiDocView }}</a>
			      </li>
			
			      <li *ngIf="globalRecordIds.length === 0" class="divider" role="separator"></li>
			      <li *ngIf="globalRecordIds.length === 0" role="menuitem">
			        <a class="text-grey"><em>{{ LOCALIZATION.selectMore }}</em></a>
			      </li>
			      <li *ngIf="globalRecordIds.length > 0" class="divider" role="separator"></li>
                   <li
                       *ngIf="globalRecordIds.length > 0 && globalRecordIds.length <= 500 && userPermissions['ROLE_ALBUM_MANAGEMENT']">
                       <a [title]="LOCALIZATION.albumAddItem"
                           (click)="addRecordsToAlbum()">{{LOCALIZATION.albumAddItem}}</a>
                   </li>
                   <li
                       *ngIf="globalRecordIds.length > 0 && globalRecordIds.length <= 500 && userPermissions['ROLE_ALBUM_MANAGEMENT']">                                    
                       <a [title]="LOCALIZATION.albumRemovePage"
                           (click)="removeRecordsFromAlbum()">{{LOCALIZATION.albumRemovePage}}</a>                                    
                   </li>
                   
                   <li *ngIf="(userPermissions['ROLE_ALBUM_MANAGEMENT'] || userPermissions['ROLE_PRODUCT_DOWNLOAD'])
                           && globalRecordIds.length > 0" role="separator" class="dropdown-divider">
                   </li>                            

                   <li *ngIf="userPermissions['ROLE_PRODUCT_REPROCESS'] && globalRecordIds.length > 0 && globalRecordIds.length <= 500"
                       role="menuitem"><a [title]="LOCALIZATION.generateThumbnail"
                           (click)="generateThumbnails()">{{LOCALIZATION.generateThumbnail}}</a>
                   </li>
                   <li *ngIf="ocr.available && userPermissions['ROLE_PRODUCT_UPDATE'] && globalRecordIds.length > 0 && globalRecordIds.length <= 500"
                       role="menuitem"><a [title]="LOCALIZATION.ocr"
                           (click)="ocrDocuments()">{{LOCALIZATION.ocr}}</a>
                   </li>
                   <li *ngIf="mapViewEnabled && userPermissions['ROLE_PRODUCT_UPDATE'] && globalRecordIds.length > 0 && globalRecordIds.length <= 500"
                       role="menuitem"><a [title]="LOCALIZATION.geotagResults"
                           (click)="geotag()">{{LOCALIZATION.geotagResults}}</a>
                   </li>

                   <li *ngIf="userPermissions['ROLE_PRODUCT_UPDATE'] && globalRecordIds.length > 0 && globalRecordIds.length <= 500"
                       role="menuitem"><a [title]="LOCALIZATION.rotateImage"
                           (click)="rotateImage()">{{LOCALIZATION.rotateImage}}</a>
                   </li>

                   <li *ngIf="userPermissions['ROLE_PRODUCT_UPDATE'] && globalRecordIds.length > 0 && globalRecordIds.length <= 500"
                       role="menuitem"><a [title]="LOCALIZATION.moveToLibrary"
                           (click)="moveToLibrary()">{{LOCALIZATION.moveToLibrary}}</a>
                   </li>
                   <!--// RM batch functions -->
                   <li *ngIf="recordsMgmtServicesEnabled && globalRecordIds.length > 0 && globalRecordIds.length <= 500 && userPermissions['ROLE_PRODUCT_UPDATE']"
                       role="separator" class="dropdown-divider">
                   </li>
                   <li
                       *ngIf="recordsMgmtServicesEnabled && globalRecordIds.length > 0 && globalRecordIds.length <= 500 && userPermissions['ROLE_PRODUCT_UPDATE']">
                       <a [title]="LOCALIZATION.addToRM"
                           (click)="fileAsRMRecords()">{{LOCALIZATION.addToRM}}</a>
                   </li>
                   <li
                       *ngIf="recordsMgmtServicesEnabled && globalRecordIds.length > 0 && globalRecordIds.length <= 500 && userPermissions['ROLE_PRODUCT_UPDATE']">
                       <a [title]="LOCALIZATION.completeRMRecordBatch"
                           (click)="completeRMRecords(true)">{{LOCALIZATION.completeRMRecordBatch}}</a>
                   </li>
                   <li
                       *ngIf="recordsMgmtServicesEnabled && globalRecordIds.length > 0 && globalRecordIds.length <= 500 && userPermissions['ROLE_PRODUCT_UPDATE']">
                       <a [title]="LOCALIZATION.completeRMRecordBatchUndo"
                           (click)="completeRMRecords(false)">{{LOCALIZATION.completeRMRecordBatchUndo}}</a>
                   </li>

                   <li *ngIf="globalRecordIds.length > 100 && globalRecordIds.length <= 500" role="separator"
                       class="dropdown-divider">
                   </li>
                   <li *ngIf="globalRecordIds.length > 100 && globalRecordIds.length <= 500" role="menuitem">
                       <a class="text-grey"><em>{{ LOCALIZATION.selectLess | formatString: 100 }}</em></a>
                   </li>

                   <li *ngIf="(userPermissions['ROLE_PRODUCT_UPDATE'] || userPermissions['ROLE_PRODUCT_REPROCESS'])
                           && globalRecordIds.length > 0 && globalRecordIds.length <= 100" role="separator"
                       class="dropdown-divider">
                   </li>

                   <li *ngIf="dxOn && userPermissions['ROLE_DECLASS_BATCH_MANAGE'] && globalRecordIds.length > 0 && globalRecordIds.length <= 100"
                       role="menuitem">
                       <a [title]="LOCALIZATION.awdxBatch"
                           (click)="dxBatchAdd()">{{LOCALIZATION.awdxBatch}}</a>
                   </li>

                   <li *ngIf="dxOn && userPermissions['ROLE_DECLASS_BATCH_MANAGE'] && globalRecordIds.length > 0 && globalRecordIds.length <= 100"
                       role="separator" class="dropdown-divider">
                   </li>

                   <li *ngIf="globalRecordIds.length > 500" role="separator" class="dropdown-divider">
                   </li>
                   <li *ngIf="globalRecordIds.length > 500" role="menuitem">
                   	<a class="text-grey"><em>{{ LOCALIZATION.selectLess | formatString: 500 }}</em></a>
                   </li>	
			    </ul>
			  </div>
			</div>
            <!-- END global record selector -->
			<!-- Desktop View (non-map view) -->
			<p *ngIf="searchResults && !searchResults.error && states.currentView !== 'M'" class="resultText desktop">
			  {{ searchResults.pageGap }} {{ LOCALIZATION.of }} {{ numberWithCommas(searchResults.total) }}
			</p>
			
			<!-- Mobile View -->
			<p *ngIf="searchResults && !searchResults.error" class="resultText mobile">
			  {{ searchResults.pageGap }} {{ LOCALIZATION.of }} {{ numberWithCommas(searchResults.total) }}
			</p>
			
			<!-- Desktop View (map view) -->
			<p *ngIf="searchResults && !searchResults.error && states.currentView === 'M'" class="resultText desktop">
			  {{ numberWithCommas(searchResults.geo_total) }} {{ LOCALIZATION.resultsForMap }}
			</p>
			
			<!-- Map View Query Display -->
			<p *ngIf="searchResults && !searchResults.error && states.currentView === 'M'" class="resultTextQuery resultText">
			  "{{ searchResults.query }}"
			</p>
			
			<!-- Blank spacer if criteria or aoiCriteria is present -->
			<p class="resultText" *ngIf="criteria || aoiCriteria">&nbsp;</p>
			<!-- Show container only if criteria or aoiCriteria -->
			<div *ngIf="criteria || aoiCriteria" class="criteriaHolder"  overflow-hide (callbackFn)="updateFlow($event)">
			  <div class="critChildren" [ngClass]="{ hide: overflowed }">
			    <!-- AOI Tag -->
			    <div *ngIf="aoiCriteria" class="tag criteriaList label label-default">
			      {{ LOCALIZATION.AOI }}
			      <i (click)="clearAOI()" class="pointMe removeTag glyphicon glyphicon-remove"></i>
			    </div>
			
			    <!-- Criteria tags -->
			    <ng-container *ngFor="let entry of criteria | keyvalue">
			    <div
			      class="tag criteriaList label label-default"
			      *ngIf="entry.value.display_value"
			    >
			      {{ entry.value.display_header }} : {{ decode(entry.value.display_value) }}
			      <i (click)="removeFacet(entry.key)" class="pointMe removeTag glyphicon glyphicon-remove"></i>
			    </div>
			    </ng-container>
			    <!-- Sort dropdown (desktop only, not on map view) -->
			    <!-- desktop -->
                <div id = "sort-button-desktop-div"
				  *ngIf="states.currentView !== 'M'"
				  class="btn-group dropdown desktop"
				  ngbDropdown 
				  #dropdownRef="ngbDropdown"
				  style="float: right;"
				  placement="bottom-right"
				>
				  <button
				    id="sort-button-desktop"
				    type="button"
				    class="btn btn-primary submit-button submit-button-sm"
				    ngbDropdownToggle
				    [disabled]="false"
				    [ngClass]="{
				      dropdown: !sort || (sort && sort.direction !== 'ASC'),
				      dropup: sort?.direction === 'ASC'
				    }"
				  >
				    Sort by
				    <span class="badge" *ngIf="sort">{{ sort?.field?.displayName ?? ''}}</span>
				    <span class="badge" *ngIf="!sort">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
				    <span class="caret"></span>
				  </button>
				
				  <ul
				    class="custom-drop sort-menu"
				    ngbDropdownMenu
				    role="menu"
				    aria-labelledby="sort-button-desktop"
				    style="min-width: 130px; max-width: 130px; max-height: 70%; overflow-y: auto;"
				  >
				    <li
				      role="menuitem"
				      *ngFor="let field of sortFieldsShow"
				      (click)="onSortSelected(field, dropdownRef)"
				      style="min-width: 120px; max-width: 120px;"
				    >
				    <!-- button 
			          class="btn btn-link text-start w-100" 
			          style="text-align: left; padding-left: 2;max-width: inherit; white-space: initial;width:100%">
			          {{ field.displayName }}
			     	</button-->
			     	<!--  width: 100%; -->
				      <a style="max-width: inherit; white-space: initial;">{{ field.displayName }}</a>
				    </li>
				  </ul>
				</div>
			  </div>
			
			  <!-- Overflowed dropdown criteria summary -->
			  <div *ngIf="overflowed && (criteria || aoiCriteria)" class="btn-group desktop dropdown" ngbDropdown 
			  #dropdownRef="ngbDropdown" autoClose="outside">
			    <button
			      id="btn-append-to-body"
			      type="button"
			      class="dropdown-toggle btn btn-sm btn-accent"
			      ngbDropdownToggle
			    >
			      {{ critCount }} {{ LOCALIZATION.searchCriteria }} <span class="caret"></span>
			    </button>
			    <ul
			      class="dropdown-menu custom-drop criteria-summary"
			      ngbDropdownMenu
			      role="menu"
			      aria-labelledby="btn-append-to-body"
			    >
			      <li *ngIf="aoiCriteria" class="row-item" role="menuitem">
			        {{ LOCALIZATION.AOI }}
			        <i (click)="clearAOI()" class="pointMe glyphicon glyphicon-remove"></i>
			      </li>
			      <li
			        class="row-item"
			        role="menuitem"
			        *ngFor="let entry of criteria | keyvalue"
			      >
			        {{ entry.value.display_header }} : {{ decode(entry.value.display_value) }}
			        <i (click)="removeFacet(entry.key)" class="pointMe glyphicon glyphicon-remove"></i>
			      </li>
			    </ul>
			  </div>
			</div>
			<div *ngIf="states.currentView !== 'M' && !isMobile" class="btn-group dropdown desktop hidden-xs" 
				 ngbDropdown 
				 #dropdownRef="ngbDropdown"
			     placement="bottom-right" 
			     [ngClass]="{ 'dropdown': !sort || (sort && sort.direction !== 'ASC'), 'dropup': sort.direction === 'ASC' }" 
			     style="float:right;">
			  <button id="sort-button" type="button" class="btn btn-primary submit-button submit-button-sm"
			          [disabled]="false" ngbDropdownToggle>
			    {{ LOCALIZATION.sortBy }} 
			    <span class="badge" *ngIf="sort">{{ sort?.field?.displayName ?? ''}}</span>
			    <span class="badge" *ngIf="!sort">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
			    <span class="caret"></span>
			  </button>
			  <ul class="custom-drop sort-menu" ngbDropdownMenu role="menu" aria-labelledby="sort-button"
			      style="min-width:130px;max-width:130px;max-height:80%;overflow-y: auto;overflow-x: hidden;">
			    <li *ngFor="let field of sortFieldsShow" role="menuitem" 
			        (click)="onSortSelected(field, dropdownRef)" style="min-width:130px;max-width:130px;">
			      <a style="max-width:inherit;white-space:initial;">{{ field.displayName }}</a>
			    </li>
			  </ul>
			</div>
			<p *ngIf="searchResults?.error" class="resultText error">{{ searchResults?.error }}</p>
			<p *ngIf="searchResults == null" class="resultText">{{ LOCALIZATION.searchPrompt }}</p>
        </div>
       
        <div id="maincontent_block" [ngClass]="{'mapViewHolder': states.currentView === 'M'}" class="relative-mobile">
           	<div *ngIf="searchResults && (!searchResults?.records || searchResults?.records?.length === 0) && states.currentView !== 'M'" class="list-group empty">
		      	<div *ngIf="!states.browseOpen"><empty-view [viewType]="'search'"></empty-view></div>
		      	<div *ngIf="states.browseOpen"><empty-view [viewType]="'browse'"></empty-view></div>
		  	</div>
		  
		  	<!-- Default Welcome Empty View -->
		  	<div *ngIf="!searchResults && states.currentView !== 'M'" class="list-group empty full yScrollOnly">
				<div *ngIf="!isFeatureEnabled('BrandEmptyView')" class="empty-view">
					<empty-view [viewType]="'welcome'"></empty-view>
				</div>
				<div *ngIf="isFeatureEnabled('BrandEmptyView')" class="empty-view">
					<brand-empty-view [viewType]="'welcome'"></brand-empty-view>
				</div>
		  	</div>
		  
		  	<!-- Map View -->
		  	<div id="mapHolder" [hidden]="states.currentView !== 'M' || !mapViewEnabled || userPermissions['BLOCK_MAP_VIEW']" class="full yScrollOnly">
		  		<map-view></map-view>
		  	</div>
		
		  	<!-- Grid View -->
			<div [hidden]="states.currentView !== 'G'" class="gridHolder full noScroll">
		  		<grid-view #gridView></grid-view>
		  	</div>
		
		  	<!-- List View -->
			<div [hidden]="states.currentView !== 'L' || userPermissions['BLOCK_LIST_VIEW']" class="listHolder full yScrollOnly">
		  		<list-view></list-view>
		  	</div>
		
		  	<!-- Thumbnail View -->
		  	<div [hidden]="states.currentView !== 'T' || userPermissions['BLOCK_THUMBNAIL_VIEW']" class="thumbsHolder full yScrollOnly">
		  		<thumbnail-view></thumbnail-view>
		  	</div>

		  	<!-- Record Management View -->
		  	<div [hidden]="states.currentView !== 'R' || !recordsMgmtServicesEnabled || !userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW']" class="listHolder full yScrollOnly">
		  		<rm-record-view></rm-record-view>
		  	</div>		  
        </div>    
		<div
		  id="maincontent_footer"
		  [ngClass]="{ mapViewHolder: states.currentView === 'M' }"
		  class="pagerHolder relative-mobile" 
		  *ngIf="(searchResults?.total ?? 0) > 0">
		  <!-- Desktop dropdown for page size -->
		  <div class="btn-group desktop dropup" ngbDropdown 
				  #dropdownRef="ngbDropdown">
		    <button
		      id="pageSizeButton"
		      type="button"
		      class="btn btn-primary submit-button submit-button-sm"
		      ngbDropdownToggle
		      [disabled]="false">
		      {{ LOCALIZATION.showing }} <span class="badge">{{ pager.size }}</span>
		      {{ LOCALIZATION.results }}
		      <span class="caret"></span>
		    </button>
		    <ul
		      class="dropdown-menu custom-drop"
		      ngbDropdownMenu
		      role="menu"
		      aria-labelledby="pageSizeButton"
		    >
		      <li
		        role="menuitem"
		        *ngFor="let pagesize of pageSizes"
		        (click)="pageSizeChanged(pagesize.value, dropdownRef)"
		      >
		        <a>{{ pagesize.name }}</a>
		      </li>
		    </ul>
		  </div>
		
		  <!-- Mobile dropdown for page size -->
		  <div class="btn-group mobile dropup flex-1" ngbDropdown 
				  #dropdownRef="ngbDropdown">
		    <button
		      id="pageSizeButtonMobile"
		      type="button"
		      class="btn btn-sm btn-primary submit-button submit-button-sm"
		      ngbDropdownToggle
		      [disabled]="false"
		    >
		      <span class="badge">{{ pager.size }}</span>
		      <span *ngIf="!isMobile">{{ LOCALIZATION.results }}</span>
		      <span class="caret"></span>
		    </button>
		    <ul
		      class="dropdown-menu custom-drop"
		      ngbDropdownMenu
		      role="menu"
		      aria-labelledby="pageSizeButtonMobile"
		    >
		      <li
		        role="menuitem"
		        *ngFor="let pagesize of pageSizes"
		        (click)="pageSizeChanged(pagesize.value, dropdownRef)"
		      >
		        <a>{{ pagesize.name }}</a>
		      </li>
		    </ul>
		  </div>
		
		  <!-- Go to page input -->
		  <div class="btn-group hidden-search-pagination" *ngIf="paginationGoTo && (searchResults?.total ?? 0)>0">
		    <input
		      style="width:60px;text-align:center;height:32px"
		      type="number"
		      min="1"
		      step="1"
		      [(ngModel)]="pager.goToPage"
		      (keyup.enter)="goToPage()"
		    />
		    <span> / {{ pager.totalPages }} &nbsp;</span>
		    <button
		      style="height:32px"
		      class="btn btn-xs btn-primary pull-right"
		      (click)="goToPage()"
		    >
		      {{ LOCALIZATION.goto }}
		    </button>
		  </div>
		
		  <!-- Desktop Pagination -->
		  <div class="flex-1" *ngIf="!isMobile && (searchResults?.total ?? 0)>0">
			  <ngb-pagination
			    [collectionSize]="searchResults?.total ?? 0"
			    [(page)]="pager.page"
			    [pageSize]="pager.size"
			    [maxSize]="pager.paginationLinks"
			    [boundaryLinks]="true"
			    (pageChange)="goToPage($event)"
			    class="pagination custom-page hidden-xs"
			    style="margin:2px 0 0 0 !important; float: right; flex: 1;"
			    size="sm"
			    previousText="&#xf053;"
			    nextText="&#xf054;"
				firstText="&#xf053;&#xf053;"
				lastText="&#xf054;&#xf054;"></ngb-pagination>
		  </div>
		
		  <!-- Mobile Pagination -->
		  <div class="flex-1" *ngIf="isMobile && (searchResults?.total ?? 0) > 0">
			<ngb-pagination
			  [collectionSize]="searchResults?.total ?? 0"
			  [(page)]="pager.page"
			  [pageSize]="pager.size"
			  (pageChange)="pageChanged()"
			  [maxSize]="1"               
			  [directionLinks]="true"     
			  [boundaryLinks]="false"     
			  [ellipses]="false"          
			  class="mobilePager only-prev-next pagination custom-page">
			</ngb-pagination>
		</div> 	
		</div>
	</div>  
  </div>
</div>
